import {Grid} from '@logistics-frontend/blocks'
import React from 'react'

import {classes} from './CardListSkeleton.classes'
import {CardListSkeletonProps} from './CardListSkeleton.types'

const CardListSkeleton: React.FC<CardListSkeletonProps> = ({cardsCount}) => {
  const amount = Array.from({length: cardsCount}, (_, index) => index)

  return (
    <div className={classes.container}>
      <Grid size="m" container>
        {amount.map(number => (
          <Grid key={number} xs={6} item>
            <div className={classes.paymentCard} />
          </Grid>
        ))}
      </Grid>
    </div>
  )
}

CardListSkeleton.displayName = 'CardListSkeleton'

export default React.memo(CardListSkeleton)
